<div class="w-screen max-w-full overflow-hidden rounded-2xl sm:max-w-128">
  <header class="flex w-full items-center gap-4 border-b p-8">
    <div
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent"
    >
      <mat-icon
        class="cursor-pointer text-white icon-size-6"
        [svgIcon]="'heroicons_outline:inbox'"
        [matDialogClose]="'back'"
      ></mat-icon>
    </div>

    <div class="flex flex-col gap-1">
      <a
        class="cursor-pointer text-sm leading-5 text-primary underline"
        [matDialogClose]="'back'"
        >Back</a
      >
      <p class="text-default text-xl font-semibold leading-6">
        {{ data.message.title }}
      </p>
    </div>
  </header>
  <!-- Content -->
  <main
    class="flex max-h-[70dvh] flex-col items-start gap-5 overflow-y-scroll p-8"
  >
    @if (data.message.imageUrl) {
      <div class="banner w-full" [style.aspect-ratio]="imageAspectRatio">
        <img
          [src]="data.message.imageUrl"
          class="h-auto w-full overflow-hidden rounded-2xl"
          alt="Message banner"
        />
      </div>
    }
    <div class="flex flex-col gap-3">
      <div class="text-default text-base leading-5 opacity-80">
        {{ data.message.body }}
      </div>
    </div>

    <!-- The sendActionForLogic answer form (Figma 1898-128286, groups 41/42):
         question, helper text, one input; the footer swaps to Cancel/Save. -->
    @if (textPopup(); as popup) {
      <div class="flex w-full flex-col gap-2">
        @if (popup.title) {
          <p class="text-default m-0 text-lg font-semibold leading-6">
            {{ popup.title }}
          </p>
        }
        @if (popup.subtitle) {
          <p class="text-default m-0 text-base leading-5 opacity-64">
            {{ popup.subtitle }}
          </p>
        }
        <mat-form-field class="mt-2 w-full">
          <input
            matInput
            [type]="popup.secureTextEntry ? 'password' : 'text'"
            [placeholder]="popup.placeholder || ''"
            [formControl]="responseControl"
            (keyup.enter)="onFormSave()"
          />
          @if (responseControl.touched && responseControl.invalid) {
            <mat-error>Please enter a valid value</mat-error>
          }
        </mat-form-field>
      </div>
    }
  </main>
  <!-- Footer -->
  <footer class="bg-dialog-footer flex justify-end gap-3 border-t px-6 py-4">
    @if (textPopup(); as popup) {
      <button class="text-base" mat-stroked-button (click)="onFormCancel()">
        {{ popup.cancelButtonTitle || 'Cancel' }}
      </button>
      <button
        class="text-base"
        mat-flat-button
        [color]="'accent'"
        [disabled]="responseControl.touched && responseControl.invalid"
        (click)="onFormSave()"
      >
        {{ popup.confirmButtonTitle || 'Save' }}
      </button>
    } @else {
      <!-- R151: neither button is guaranteed on the wire; reading `.text` off a
           missing one threw mid-render and left both buttons blank. -->
      @if (data.message.canDismiss || data.message.dismissButton) {
        <button class="text-base" mat-stroked-button (click)="onClose()">
          {{ data.message.dismissButton?.text || 'Dismiss' }}
        </button>
      }
      @if (data.message.actionButton; as action) {
        <button
          class="text-base"
          mat-flat-button
          [color]="'accent'"
          (click)="onAction()"
        >
          {{ action.text || 'Review' }}
        </button>
      }
    }
  </footer>
</div>
